const CONFIG = {
  dev: {
    elsaIcon: "https://d3oc9469khle5q.cloudfront.net/ELSA/elsa-logo-01.png",
    production: false,
    captchaSiteKey: '6LerZhsiAAAAAMjF79HlfVerlMMN73pbeIKFQdTE',
    internalApiUrl: 'https://hk-stag.elsaspeak.com',
    userServerApiUrl: 'https://staging.elsanow.co',
    baseApiUrl: 'https://staging.elsanow.co',
    paymentApiURL: 'https://web-stag.elsanow.co',
    backendPaymentApiUrl: 'https://payment-stag.elsanow.io',
    universalLoginUrl: 'http://localhost:8000',
    universalLoginClientId: '1f45a1bc-acfb-4513-bfd0-44e7e54feb43'
  },
  staging: {
    elsaIcon: "https://d3oc9469khle5q.cloudfront.net/ELSA/elsa-logo-01.png",
    production: false,
    captchaSiteKey: '6LerZhsiAAAAAMjF79HlfVerlMMN73pbeIKFQdTE',
    internalApiUrl: 'https://hk-stag.elsaspeak.com',
    userServerApiUrl: 'https://staging.elsanow.co',
    baseApiUrl: 'https://staging.elsanow.co',
    paymentApiURL: 'https://web-stag.elsanow.co',
    backendPaymentApiUrl: 'https://payment-stag.elsanow.io',
    universalLoginUrl: 'https://id-stg.elsanow.co',
    universalLoginClientId: '1f45a1bc-acfb-4513-bfd0-44e7e54feb43'
  },
  production: {
    elsaIcon: "https://d38mu8cimsbtsp.cloudfront.net/ELSA/elsa-logo-01.png",
    production: true,
    captchaSiteKey: '6LerZhsiAAAAAMjF79HlfVerlMMN73pbeIKFQdTE',
    internalApiUrl: 'https://hk.elsaspeak.com',
    userServerApiUrl: 'https://pool.elsanow.io',
    baseApiUrl: 'https://pool.elsanow.io',
    paymentApiURL: 'https://elsaspeak.com',
    backendPaymentApiUrl: 'https://pool.elsanow.io/payment',
    universalLoginUrl: 'https://accounts.elsaspeak.com',
    universalLoginClientId: '1f45a1bc-acfb-4513-bfd0-44e7e54feb43'
  },
};

export default function env() {
  const currentStage = process.env.REACT_APP_ENV || "dev";

  switch (currentStage) {
    case "production":
      return CONFIG.production;
    case "staging":
      return CONFIG.staging;
    default:
      return CONFIG.dev;
  }
}
